import React from 'react';
import PropTypes from 'prop-types';
import _partition from 'lodash/partition';
import NAV_DATA from '@zola-helpers/client/dist/es/constants/navConstants';

import SubMenuColumn from 'components/navV2/navPrimarySubMenu/SubMenuColumn';

import css from '../../SubMenuColumn/subMenuColumn.module.less';

const {
  PRIMARY: { REGISTRY, WEBSITE, PAPER, GUEST_LIST, WEDDING_BOUTIQUE, VENDORS },
} = NAV_DATA;

const TwoRowColContainer = ({ data, className }) => {
  const [rightCol, rowColumns] = _partition(data.children, (i) => i.borderLeft);
  // split the columns into two rows (make the top row 1 longer if necessary):
  const topRowCount = Math.ceil(rowColumns.length / 2);
  const [topRow, botRow] = rowColumns.reduce(
    (acc, col, i) =>
      i < topRowCount ? [acc[0].concat([col]), acc[1]] : [acc[0], acc[1].concat([col])],
    [[], []]
  );

  return (
    <div className={className}>
      <div className={css.twoRowContainer}>
        <div className={css.colRow}>
          {topRow.map((child, i) => {
            return (
              <SubMenuColumn
                headline={child.headline}
                links={child.children}
                borderLeft={child.borderLeft}
                twoColumns={child.twoColumns}
                key={i}
              />
            );
          })}
        </div>
        <div className={css.colRow}>
          {botRow.map((child, i) => {
            return (
              <SubMenuColumn
                headline={child.headline}
                links={child.children}
                borderLeft={child.borderLeft}
                twoColumns={child.twoColumns}
                key={i}
              />
            );
          })}
        </div>
      </div>
      {rightCol.map((child, i) => {
        return (
          <SubMenuColumn
            headline={child.headline}
            links={child.children}
            borderLeft={child.borderLeft}
            twoColumns={child.twoColumns}
            key={i}
          />
        );
      })}
    </div>
  );
};

TwoRowColContainer.propTypes = {
  data: PropTypes.shape({
    callToAction: PropTypes.shape({
      path: PropTypes.string,
      title: PropTypes.string,
      items: PropTypes.arrayOf(PropTypes.string),
    }),
    userActionsLinks: PropTypes.arrayOf(
      PropTypes.shape({
        path: PropTypes.string,
        title: PropTypes.string,
      })
    ),
    title: PropTypes.string,
    id: PropTypes.oneOf([REGISTRY, WEBSITE, PAPER, GUEST_LIST, WEDDING_BOUTIQUE, VENDORS]),
    isActive: PropTypes.bool,
    children: PropTypes.arrayOf(
      PropTypes.shape({
        headline: PropTypes.string,
        borderLeft: PropTypes.bool,
        children: PropTypes.arrayOf(
          PropTypes.shape({
            title: PropTypes.string.isRequired,
            path: PropTypes.string.isRequired,
          })
        ),
      })
    ).isRequired,
  }),
  className: PropTypes.string,
};

export default TwoRowColContainer;
